// @index('./*.ts', pp => `export * from '${pp.path}';`)
export * from './IQueryShortcutOptions';
export * from './ShortcutType';
export * from './TRootOptionsShortcutFnReturn';
